import {
    INITIALIZE,
    INITIALIZE_FAILURE,
    INITIALIZE_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import fetchCountries from './fetchCountries';
import fetchProducts from './fetchProducts';
import fetchTemplates from './fetchTemplates';

export default (branchOffice) => (dispatch) => {
    dispatch(actions[INITIALIZE]());
    Promise.all([
        dispatch(fetchCountries()),
        dispatch(fetchProducts()),
        dispatch(fetchTemplates(branchOffice)),
    ])
        .then(() => dispatch(actions[INITIALIZE_SUCCESS]()))
        .catch(() => dispatch(actions[INITIALIZE_FAILURE]()));
};
